import { getPropsFromNode, nodeIs, nodeListToArray } from '../utils'
import { ArticleCodeblock } from '../../components/molecule/ArticleContent/entry'
import { h } from '../parser/utils'

export const NAME = 'pre-code'

export const COMPONENTS = {
  ArticleCodeblock,
}

export function matches(node) {
  return nodeIs(node, 'pre') &&
    node.querySelectorAll(':scope > code').length !== 0
}

export async function transform (node, next, ctx) {
  const codeNode = node.querySelector(':scope > code')

  const nodes = nodeListToArray(codeNode.childNodes)
    .filter(node => node.nodeName.toLowerCase() !== 'br')

  const children = await next(nodes, ctx)

  const props = getPropsFromNode(node)
  const codeProps = getPropsFromNode(codeNode)

  return h(
    ArticleCodeblock,
    {
      ...codeProps,
      ...props,
      offset: true,
    },
    ...children,
  )
}
